<template>

  <div style="height: 100%;overflow: hidden;">
    <van-tabs color="#D6BE93" v-model="state" @change="onChange">
      <van-tab title="未使用"></van-tab>
      <van-tab title="已使用"></van-tab>
      <van-tab title="已过期"></van-tab>
    </van-tabs>
    <div class="coupon">
      <div class="duihuan-box">
        <van-field class="code-input" v-model="code" placeholder="请输入优惠码" />

        <div @click="onExchange" class="duihuan">兑换</div>
      </div>
      <!-- <div v-for="(item,i) in couponListUi" :key="i">111</div> -->
      <van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="1">

        <coupon :my="false" :stateText="state" v-for="(item,index) in couponListUi" :key="index" :coupinItem="item">
        </coupon>
      </van-list>

    </div>
    <!-- <div style="width: 100%;height: 15px;background-color: white;"></div>
    <van-coupon-list :coupons="coupons" :chosen-coupon="chosenCoupon" :disabled-coupons="disabledCoupons" :show-close-button="showclosebutton" :show-count="showcountNumber" :empty-image="emptyimage" @change="onChange" @exchange="onExchange" /> -->
  </div>
</template>


<script>
import { CouponList, Toast } from "vant";
import { couponExchange, couponMylist } from "@/api/index";
import { Dialog } from "vant";
import coupon from "@/components/coupon";

export default {
  components: { CouponList, coupon },
  name: "mycoupon",
  data() {
    return {
      emptyimage: "https://img.yzcdn.cn/vant/coupon-empty.png",
      showcountNumber: false,
      showclosebutton: false,
      showList: true,
      chosenCoupon: -1,
      couponListUi: [],
      coupondataInfo: {
        status: 0,
        page: 1,
        size: 10
      },
      code: "",
      state: 0,
      loading: false,
      finished: false
    };
  },

  mounted() {
    this.getcouponList(this.coupondataInfo);
    // this.getdisabledCoupons(this.coupondataInfo);
  },
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        const nextPaging = {
          status: this.coupondataInfo.status,
          page: this.coupondataInfo.page + 1,
          size: 10
        };
        this.coupondataInfo = nextPaging;
        this.getcouponList(this.coupondataInfo);
      }, 500);
    },
    getcouponList(data) {
      couponMylist(data).then(res => {
        if (res.data.errno == 0) {
          console.log(res);
          let couponListArr = [];
          res.data.data.data.forEach((element, index) => {
            let start_str = element.startTime.replace(/-/g, "/");
            var start_date = new Date(start_str);
            let end_str = element.endTime.replace(/-/g, "/");
            var end_date = new Date(end_str);
            let dataM = "1970-01-01 00:00:00".replace(/-/g, "/");
            var data_Midel = new Date(dataM);
            var start_num = (start_date - data_Midel) / 1000;
            var end_num = (end_date - data_Midel) / 1000;
            let couponItem = {
              id: element.id,
              available: index,
              condition: `满${element.min}可用`,
              reason: "时间过期",
              value: index,
              name: element.name,
              startAt: start_num,
              endAt: end_num,
              valueDesc: element.discount,
              unitDesc: "元",
              description: element.desc
            };
            couponListArr.push(couponItem);
          });
          this.couponListUi = this.couponListUi.concat(couponListArr);
          this.loading = false;
          console.log(this.couponListUi.length);
          console.log(res.data.data.count);
          // // 数据全部加载完成
          if (this.couponListUi.length == res.data.data.count) {
            this.finished = true;
          }
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg
          });
        }
      });
    },
    onChange(index) {
      console.log(index);
      this.couponListUi = [];
      this.coupondataInfo.status = index;
      this.getcouponList(this.coupondataInfo);
    },
    onExchange() {
      let data = {
        code: this.code
      };
      // alert(code);
      couponExchange(data).then(res => {
        console.log(res);
        if (res.data.errno == 0) {
          Toast("兑换成功");
          this.code = "";

          this.couponListUi = [];
          this.coupondataInfo = {
            status: 0,
            page: 1,
            size: 10
          };
          this.getcouponList(this.coupondataInfo);
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg
          });
        }
      });
    }
  }
};
</script>


<style scoped lang="scss">
/deep/ .van-coupon__description {
  text-align: left;
  margin: 0;
}
.coupon {
  height: 100%;
  overflow-y: scroll;
  padding: 1rem 2rem 4rem;
  box-sizing: border-box;
}
.duihuan-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  .code-input {
    flex: 1;
    height: 3.6rem;
    line-height: 3.6rem;
    box-sizing: border-box;
    padding: 0 3rem;
    border: 1px solid rgba(66, 66, 66, 0.1);
    border-radius: 8px;
  }
  .duihuan {
    background: #e5e5e5;
    border: 1px solid rgba(66, 66, 66, 0.1);
    border-radius: 8px;
    font-family: PingFangSC-Regular;
    font-size: 1.6rem;
    color: #424242;
    letter-spacing: 0;
    text-align: center;
    line-height: 3.6rem;
    width: 6.6rem;
    height: 3.6rem;
    text-align: center;
    margin-left: 1rem;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/person/mycoupon.vue